import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Images/18.KURBAN_ORG_LOGO.svg'
import _imports_1 from '@/assets/Images/tr.png'
import _imports_2 from '@/assets/Images/en.png'


const _hoisted_1 = {
  href: "https://mec.org.tr/kurban/",
  class: "company"
}
const _hoisted_2 = { class: "language" }
const _hoisted_3 = { class: "wakalah-query" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "türkçe"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "english"
}, null, -1)
const _hoisted_7 = { class: "content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("footer", null, " © Copyright 2024, MEC Vakfı. Her hakkı saklıdır. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", {
      class: _normalizeClass({ show: _ctx.isScrollDown })
    }, [
      _createElementVNode("a", _hoisted_1, [
        _createElementVNode("img", {
          class: _normalizeClass({ small: _ctx.isScrollDown }),
          src: _imports_0,
          alt: "mec logo",
          height: "250"
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_BaseButton, {
            text: _ctx.$t('btnQuery.value'),
            onOnSubmit: _ctx.toWakalStatus
          }, null, 8, ["text", "onOnSubmit"])
        ]),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLang('tr')))
        }, [
          _hoisted_4,
          _createTextVNode(" TR ")
        ]),
        _hoisted_5,
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLang('en')))
        }, [
          _hoisted_6,
          _createTextVNode(" EN ")
        ])
      ])
    ], 2),
    _createElementVNode("main", _hoisted_7, [
      _createVNode(_component_router_view)
    ]),
    _hoisted_8
  ]))
}